import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import MobileCheckoutBar from "./MobileCheckoutBar";
import { calculateCartItemTotal } from "../utils/CartCalculation";

// Pages with their own basket on screen (the Order page has this same bar already)
const HIDDEN_PATHS = ["/order-online", "/checkout", "/payment-success"];

// On phones, the bottom basket bar follows the customer to every page once the basket has items
const MobileBasketBar = () => {
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const cartCount = cartItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
  if (cartCount === 0 || HIDDEN_PATHS.some((p) => location.pathname.startsWith(p))) return null;

  const grandTotal = cartItems
    .reduce((acc, cartItem) => acc + calculateCartItemTotal(cartItem).total * (Number(cartItem.quantity) || 0), 0)
    .toFixed(2);

  return (
    <>
      <MobileCheckoutBar
        cartCount={cartCount}
        grandTotal={grandTotal}
        isBasketOpen={false}
        onToggleBasket={() => navigate("/order-online", { state: { openBasket: true } })}
      />
      {/* keeps the bottom of the page clear of the fixed bar on phones */}
      <div aria-hidden="true" className="h-[80px] min-[901px]:hidden" />
    </>
  );
};

export default MobileBasketBar;
